import { Logo } from '@/components/layout/Logo'
import { cn } from '@/lib/utils'

/** Full-viewport shell shown while JS loads or route `beforeLoad` (auth bootstrap) runs. */
export function AppBootScreen({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        'bg-bg text-text-3 flex h-full min-h-dvh w-full flex-col items-center justify-center gap-4',
        className,
      )}
      role="status"
      aria-live="polite"
      aria-label="Loading application"
    >
      <Logo
        width={48}
        height={48}
        className="motion-safe:animate-pulse rounded-[20%] opacity-90"
      />
      <span className="flex items-center gap-1.5 py-0.5" aria-hidden="true">
        <span className="animate-thinking-dot size-1.5 rounded-full bg-gradient-to-tr from-blue-600 to-indigo-500 shadow-[0_0_6px_rgba(59,130,246,0.45)] dark:from-blue-400 dark:to-indigo-300" />
        <span className="animate-thinking-dot size-1.5 rounded-full bg-gradient-to-tr from-indigo-600 to-violet-500 shadow-[0_0_6px_rgba(99,102,241,0.45)] [animation-delay:160ms] dark:from-indigo-400 dark:to-violet-300" />
        <span className="animate-thinking-dot size-1.5 rounded-full bg-gradient-to-tr from-violet-600 to-fuchsia-500 shadow-[0_0_6px_rgba(168,85,247,0.45)] [animation-delay:320ms] dark:from-violet-400 dark:to-fuchsia-300" />
      </span>
    </div>
  )
}
